import { PURCHASE_ORDER_STATUSES_PRE_APPROVAL } from "@finway-group/shared/lib/models/purchaseOrder/purchaseOrderStatus.enum"
import React from "react"
import { useTranslation } from "react-i18next"
import { CreditCardSection } from "~Components/creditCard/CreditCardSection"
import { useCardById } from "~Shared/hooks/creditCard.hooks"
import { PurchaseOrder } from "../types/PurchaseOrder.interfaces"
import { isCardMissing } from "../types/utils/helper.util"

interface PurchaseOrderCreditCardSectionProps {
    purchaseOrder: PurchaseOrder
}

export const PurchaseOrderCreditCardSection = ({ purchaseOrder }: PurchaseOrderCreditCardSectionProps) => {
    const { t } = useTranslation()
    const { card, isLoadingCard } = useCardById(purchaseOrder.cardId)

    const createInfoAlertMessage = () => {
        if (PURCHASE_ORDER_STATUSES_PRE_APPROVAL.includes(purchaseOrder.state.currentState)) {
            return t("info:purchase_order.card.one_time_card_creation_on_approval")
        }
        if (isCardMissing(purchaseOrder)) {
            return t("info:purchase_order.card.one_time_card_missing")
        }
        return undefined
    }

    if (!purchaseOrder.createCard) {
        return null
    }

    return (
        <CreditCardSection
            card={card}
            isCardLoading={isLoadingCard}
            cardId={purchaseOrder.cardId}
            requestedBy={purchaseOrder.requestedBy}
            currency={purchaseOrder.currency}
            infoAlertMessage={createInfoAlertMessage()}
        />
    )
}
